// mutations
const mutations = {
  setLogin(state, login) {
    state.login = login;
  },
  setShipmentDetail(state, shipmentDetail) {
    state.shipmentDetail = shipmentDetail;
  },
  setShipmentBatchDetail(state, shipmentBatchDetail) {
    state.shipmentBatchDetail = shipmentBatchDetail;
  },
};

export default mutations;
